import React from 'react'
import { withRouter } from 'react-router-dom'

class ScrollManager extends React.PureComponent {

  componentDidMount () {
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual'
    }
  }

  componentWillUnmount () {
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'auto'
    }
  }

  getSnapshotBeforeUpdate (prevProps, prevState) {
    sessionStorage.setItem(prevProps.location.key, window.scrollY)
    return null
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      requestAnimationFrame(() => {
        const scrollY = sessionStorage.getItem(this.props.location.key) || 0
        window.scrollTo(0, parseInt(scrollY))
      })
    }
  }

  render () {
    return null
  }
}

export default withRouter(ScrollManager)
